import {LitElement, html, css} from 'lit';
import {connect} from 'pwa-helpers';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import store from '../../store';
import {selectFamilyConfig, selectLanguage} from '../../selectors';
import checkmark from '../../../icons/checkmark';
import downSmall from '../../../icons/down-small';

@customElement('family-list-filter')
export class FamilyListFilter extends connect(store)(LitElement) {

	static styles = css`
		:host {

		}
		.familyListFilter {
			width: 260px;
			position: relative;
		}

		.label {
			background-color: var(--fix-color-black);
			width: 100%;
			cursor: pointer;
			font: var(--font-widget-label);
			color: var(--fix-color-white);
			display: flex;
			flex-direction: row;
			border: 1px solid var(--fix-color-border);
			padding: var(--very-small-padding);
			gap: var(--small-padding);
		}
		.count {
			color: var(--fix-color-black);
			background-color: var(--fix-color-selected);
			font: var(--font-widget-label);
			border-radius: 50%;
			width: 16px;
			height: 16px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.icon {
			color: var(--fix-color-white);
			margin-left: auto;
			width: 16px;
			height: 16px;
			transition: transform 0.25s ease-out;
			transform: rotate(0deg);
		}
		.active .icon {
			transform: rotate(180deg);
		}
		.options {
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			border: 1px solid var(--fix-color-border);
			background-color: var(--fix-color-black);
			position: absolute;
			width: 100%;
			z-index: 1;
		}
		.option {
			display: flex;
			flex-direction: row;
			gap: var(--very-small-padding);
			text-align: left;
			background-color: var(--fix-color-black);
			width: 100%;
			font: var(--font-widget-label);
			color: var(--fix-color-white);
			padding: var(--very-small-padding);
			cursor: pointer;
			border: none;
			transition: background-color 0.25s ease-out;
		}
		.option:hover {
			background-color: var(--fix-color-selected);
		}
		.checkbox {
			opacity: 0.25;
			transition: opacity 0.25s ease-out;
		}
		.selected .checkbox {
			opacity: 1;
		}
	`;

	@property()
	active = false;

	@property()
	attribute = [];

	@property()
	selected = [];

	constructor() {
		super();
		this.selected = [];
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.status = state.status;
		this.lang = selectLanguage(state);
		this.familyConfig = selectFamilyConfig(state);
	}

	connectedCallback() {
		super.connectedCallback();
		window.addEventListener('click', (e) => this.onClickOutside(e));
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		window.removeEventListener('click', (e) => this.onClickOutside(e));
	}

	showOptions(e) {
		this.active = !this.active;
	}
	onClickOutside(e) {
		const path = e.composedPath().map(el => el.id);
		if (!path.includes('familyListFilter_'+this.attribute.id)) {
			this.active = false;
		}
	}

	toggle(value) {
		if (this.selected.includes(value)) {
			this.selected = this.selected.filter(v => v !== value);
		} else {
			this.selected.push(value);
		}
		this.requestUpdate();

		const selectedEvent = new CustomEvent('optionSelected', {
			detail: {
				id: this.attribute.id,
				selected: this.selected,
			}
		});
		this.dispatchEvent(selectedEvent);
	}
	isSelected(value) {
		return this.selected.includes(value);
	}

	render() {
		return html`
			<div id="familyListFilter_${this.attribute.id}" class="familyListFilter ${classMap({active: this.active})}">
				<button class="label" @click=${this.showOptions}>
					<div class="text">${this.attribute.label[this.lang]}</div>
					${when(this.selected.length > 0, () => html`<div class="count">${this.selected.length}</div>`)}
					<div class="icon">${downSmall}</div>
				</button>
				${when(this.active, () => html`
					<div class="options">
						${repeat(
							this.attribute.options,
							option => option.value,
							option => html`<button @click=${() => this.toggle(option.value)} class="option ${classMap({selected: this.isSelected(option.value)})}">
								<span class="checkbox">${checkmark}</span>
								<span class="optionLabel">${option.label[this.lang]}</span>
							</button>`
						)}
					</div>
				`)}
			</div>
		`;
	}
}
